const NoWrapContainer = ({ children }) => {
    return <div className="d-flex flex-nowrap py-0 my-0">{children}</div>;
  };
  
  export default NoWrapContainer;